<template>
  <el-form-item
    v-if="showItemFlag && showWidget"
    :label-width="
      widget.options.labelWidth >= 0
        ? widget.options.labelWidth + 'px'
        : isShowLabel
          ? ''
          : '1'
    "
    :prop="disabled ? '' : itemProps"
    :rules="disabled ? null : ruleSetFormItem ? itemRules : null"
    class="sw-set-table-info"
    :class="{
      [widget.options.customClass]: widget.options.customClass ? true : false,
      'sw-is-mobile': isMobile ? true : false,
    }"
  >
    <span slot="label" v-if="widget.showName && isShowLabel">
      <el-tooltip
        v-if="widget.options.customDesc"
        placement="bottom-start"
        effect="light"
      >
        <div slot="content" class="sw-form-desc-content">
          {{ widget.options.customDesc }}
        </div>
        <span class="sw-form-desc">
          <i class="el-icon-question"></i>
        </span>
      </el-tooltip>
      {{ widget.name }}
    </span>
    <div v-if="config.justShow" style="height: 100%">
      <template v-if="widget.type === 'editor'">
        <div v-html="dataModel"></div>
      </template>
      <template v-else-if="widget.type === 'swtext'">
        <div
          v-if="!widget.options.isTextEditor"
          v-html="widget.options.defaultValue"
        ></div>
        <div
          v-if="widget.options.isTextEditor"
          class="sw-edit-text ql-editor"
          v-html="widget.options.defaultValue"
        ></div>
      </template>
      <template v-else-if="widget.type === 'file'">
        <div class="sw-file-show">
          <a v-for="file in dataModel" :key="file.id" :href="file.url">{{
            file.name
          }}</a>
        </div>
      </template>
      <template v-else-if="widget.type === 'imgupload'">
        <fm-upload
          v-model="dataModel"
          :disabled="disabled"
          :style="{ width: widget.options.width }"
          :width="widget.options.size.width"
          :height="widget.options.size.height"
          :multiple="widget.options.multiple"
          :length="widget.options.length"
          :app-id="widget.options.appId"
          :is-delete="widget.options.isDelete"
          :min="widget.options.min"
          :is-edit="widget.options.isEdit"
          :action="widget.options.action"
          :show-img="true"
        ></fm-upload>
      </template>
      <template
        v-else-if="
          widget.type === 'radio' ||
          widget.type === 'checkbox' ||
          widget.type === 'select'
        "
      >
        <template v-if="widget.options.showLabel">
          <span
            v-for="(item, index) in widget.options.optionType !== 'static'
              ? widget.options.remoteOptions
              : widget.options.options"
            :key="index"
          >
            <span
              v-if="
                dataModel && item.value && dataModel.indexOf(item.value) !== -1
              "
              style="padding-right: 6px"
              >{{ item.label }}</span
            >
          </span>
        </template>
        <span v-if="!widget.options.showLabel">{{ dataModel }}</span>
      </template>
      <template
        v-else-if="
          widget.type === 'input' &&
          widget.options.hasOwnProperty('carNumberOptions')
        "
      >
        <!-- 是否为车牌组件 -->
        <car-number
          :value.sync="dataModel"
          :options="widget.options.carNumberOptions"
          :disabled="disabled"
        />
      </template>
      <template v-else>{{ dataModel }}</template>
    </div>
    <div v-if="!config.justShow" style="height: 100%">
      <template v-if="widget.type === 'input'">
        <!-- 是否为车牌组件 -->
        <template v-if="widget.options.hasOwnProperty('carNumberOptions')">
          <car-number
            :value.sync="dataModel"
            :options="widget.options.carNumberOptions"
            :disabled="disabled"
            :model="widget.model"
          />
        </template>
        <!-- 普通input组件 -->
        <template v-else>
          <el-input
            v-if="
              widget.options.dataType === 'number' ||
              widget.options.dataType === 'integer' ||
              widget.options.dataType === 'float'
            "
            :type="
              widget.options.dataType === 'float'
                ? 'number'
                : widget.options.dataType
            "
            :disabled="disabled"
            v-model.number="dataModel"
            :placeholder="widget.options.placeholder"
            :style="{ width: widget.options.width }"
            :maxlength="widget.options.length"
            show-word-limit
            @[event]="eventMethod"
            @input="
              handleMaxlength(
                dataModel,
                widget.options.length,
                widget.options.dataType
              )
            "
          >
            <template
              slot="append"
              v-if="
                widget.suffix && widget.suffix !== null && widget.suffix !== ''
              "
              >{{ widget.suffix }}</template
            >
          </el-input>
          <el-input
            v-else
            type="text"
            :disabled="disabled"
            v-model="dataModel"
            :title="disabled ? dataModel : ''"
            :placeholder="widget.options.placeholder"
            :style="{ width: widget.options.width }"
            :maxlength="widget.options.length"
            @[event]="eventMethod"
          >
            <template
              slot="append"
              v-if="
                widget.suffix && widget.suffix !== null && widget.suffix !== ''
              "
              >{{ widget.suffix }}</template
            >
          </el-input>
        </template>
      </template>

      <template v-if="widget.type === 'textarea'">
        <!-- :rows="widget.options.defaultRows ? widget.options.defaultRows : 5" -->
        <el-input
          type="textarea"
          :autosize="{
            minRows: widget.options.defaultRows
              ? widget.options.defaultRows
              : 5,
          }"
          v-model="dataModel"
          :disabled="disabled"
          :placeholder="widget.options.placeholder"
          :style="{ width: widget.options.width, height: '100%' }"
          :maxlength="widget.options.length"
          show-word-limit
          @[event]="eventMethod"
        ></el-input>
        <div
          class="textareaTip"
          :class="
            dataType !== 'handle' || (dataType === 'handle' && disabled)
              ? 'hideBtn'
              : ''
          "
        >
          <div class="tipPart">
            <span class="tipTitle" v-if="widget.options.approvalTipValue"
              >常用意见：</span
            >
          </div>
          <div class="languageList">
            <template>
              <el-button
                v-for="(item, index) in widget.options.ApprovalLanguage"
                :class="currentIndex === index ? 'actived' : ''"
                :key="index"
                :disabled="
                  approveTip && approveTip == 'approve' ? disabled : true
                "
                @click="writeIn(index)"
              >
                {{ item }}
              </el-button>
            </template>
          </div>
        </div>
      </template>

      <template v-if="widget.type === 'number'">
        <el-input-number
          v-model="dataModel"
          :min="widget.options.min"
          :max="widget.options.max"
          :disabled="disabled"
          :style="{ width: widget.options.width }"
          :step="widget.options.step"
          :step-strictly="widget.options.stepStrictly"
          @[event]="eventMethod"
        ></el-input-number>
      </template>

      <template v-if="widget.type === 'radio'">
        <el-radio-group
          v-model="dataModel"
          :style="{ width: widget.options.width }"
          :disabled="disabled"
          @[event]="eventMethod"
        >
          <el-radio
            :style="{
              display: widget.options.inline ? 'inline-block' : 'block',
            }"
            :label="item.value"
            v-for="(item, index) in widget.options.optionType !== 'static'
              ? widget.options.remoteOptions
              : widget.options.options"
            :key="index"
          >
            <template v-if="widget.options.optionType !== 'static'">{{
              item.label
            }}</template>
            <template v-else>{{
              widget.options.showLabel ? item.label : item.value
            }}</template>
          </el-radio>
        </el-radio-group>
      </template>

      <template v-if="widget.type === 'checkbox'">
        <el-checkbox-group
          v-model="dataModel"
          :style="{ width: widget.options.width }"
          :disabled="disabled"
          @[event]="eventMethod"
        >
          <el-checkbox
            :style="{
              display: widget.options.inline ? 'inline-block' : 'block',
            }"
            :label="item.value"
            v-for="(item, index) in widget.options.optionType !== 'static'
              ? widget.options.remoteOptions
              : widget.options.options"
            :key="index"
          >
            <template v-if="widget.options.optionType !== 'static'">{{
              item.label
            }}</template>
            <template v-else>{{
              widget.options.showLabel ? item.label : item.value
            }}</template>
          </el-checkbox>
        </el-checkbox-group>
      </template>

      <template v-if="widget.type === 'time'">
        <el-time-picker
          v-model="dataModel"
          :is-range="widget.options.isRange"
          :placeholder="widget.options.placeholder"
          :start-placeholder="widget.options.startPlaceholder"
          :end-placeholder="widget.options.endPlaceholder"
          :picker-options="{
            selectableRange: `${widget.options.startTime || '00:00:00'} - ${
              widget.options.endTime || '23:59:59'
            }`,
          }"
          :readonly="widget.options.readonly"
          :disabled="disabled"
          :editable="widget.options.editable"
          :clearable="widget.options.clearable"
          :arrowControl="widget.options.arrowControl"
          :value-format="widget.options.format"
          :style="{ width: widget.options.width }"
          @[event]="eventMethod"
        ></el-time-picker>
      </template>

      <template v-if="widget.type === 'date'">
        <el-date-picker
          v-model="dataModel"
          :type="widget.options.type"
          :placeholder="widget.options.placeholder"
          :start-placeholder="widget.options.startPlaceholder"
          :end-placeholder="widget.options.endPlaceholder"
          :readonly="widget.options.readonly"
          :disabled="disabled"
          :editable="widget.options.editable"
          :clearable="widget.options.clearable"
          :value-format="
            widget.options.timestamp ? 'timestamp' : widget.options.format
          "
          :format="widget.options.format"
          :style="{ width: widget.options.width }"
          :picker-options="widget.options.pickerOptions"
          @[event]="eventMethod"
          @change="handleDateChange"
        ></el-date-picker>
      </template>

      <template v-if="widget.type === 'rate'">
        <el-rate
          v-model.number="dataModel"
          :max="widget.options.max"
          :disabled="disabled"
          :allow-half="widget.options.allowHalf"
          @[event]="eventMethod"
        ></el-rate>
      </template>

      <template v-if="widget.type === 'color'">
        <el-color-picker
          v-model="dataModel"
          :disabled="disabled"
          :show-alpha="widget.options.showAlpha"
          @[event]="eventMethod"
        ></el-color-picker>
      </template>

      <template v-if="widget.type === 'select'">
        <el-select
          v-model="dataModel"
          :disabled="disabled"
          :multiple="widget.options.multiple"
          :clearable="widget.options.clearable"
          :placeholder="widget.options.placeholder"
          :style="{ width: widget.options.width }"
          :filterable="widget.options.filterable"
          @[event]="eventMethod"
        >
          <el-option
            v-for="(item, index) in widget.options.optionType !== 'static'
              ? widget.options.remoteOptions
              : widget.options.options"
            :key="index"
            :value="item.value"
            :label="
              widget.options.showLabel || widget.options.optionType !== 'static'
                ? item.label
                : item.value
            "
          ></el-option>
        </el-select>
      </template>

      <template v-if="widget.type === 'switch'">
        <el-switch
          v-model="dataModel"
          :disabled="disabled"
          @[event]="eventMethod"
        ></el-switch>
      </template>

      <template v-if="widget.type === 'slider'">
        <el-slider
          v-model="dataModel"
          :min="widget.options.min"
          :max="widget.options.max"
          :disabled="disabled"
          :step="widget.options.step"
          :show-input="widget.options.showInput"
          :range="widget.options.range"
          :style="{ width: widget.options.width }"
          @[event]="eventMethod"
        ></el-slider>
      </template>

      <template v-if="widget.type === 'imgupload'">
        <fm-upload
          v-model="dataModel"
          :disabled="disabled"
          :style="{ width: widget.options.width }"
          :width="widget.options.size.width"
          :height="widget.options.size.height"
          :multiple="widget.options.multiple"
          :length="widget.options.length"
          :app-id="widget.options.appId"
          :is-delete="widget.options.isDelete"
          :min="widget.options.min"
          :is-edit="widget.options.isEdit"
          :action="widget.options.action"
          :allowable-type="widget.options.allowableType"
          :widget="widget"
          :yyid="yyid"
        ></fm-upload>
      </template>

      <template v-if="widget.type === 'editor'">
        <fm-editor
          v-model="dataModel"
          :width="widget.options.width"
          :height="widget.options.height"
          :disabled="disabled"
          @[event]="eventMethod"
        ></fm-editor>
      </template>

      <template v-if="widget.type === 'cascader'">
        <sw-cascader
          :widget="widget"
          :cascader.sync="dataModel"
          :config="config"
          :disabled="disabled"
          :models="models"
        ></sw-cascader>
      </template>

      <template v-if="widget.type === 'file'">
        <sw-file
          v-model="dataModel"
          :disabled="disabled"
          :length="widget.options.length"
          :multiple="widget.options.multiple"
          :action="widget.options.action"
          :app-id="widget.options.appId"
          :show-type="widget.options.showType"
          :allowable-type="widget.options.allowableType"
          :widget="widget"
          :instanceJson="instanceJson"
          :ffid="ffid"
          :yyid="yyid"
        ></sw-file>
      </template>

      <template v-if="widget.type === 'address'">
        <sw-address
          :widget="widget"
          v-model="dataModel"
          :config="config"
          :disabled="disabled"
        ></sw-address>
      </template>
      <template v-if="widget.type === 'organization'">
        <sw-cascader
          :widget="widget"
          :cascader.sync="dataModel"
          :config="config"
          :disabled="disabled"
          :dataType="dataType"
        ></sw-cascader>
      </template>

      <template v-if="widget.type === 'table'">
        <sw-table :widget="widget"> </sw-table>
      </template>

      <template v-if="widget.type === 'user'">
        <template v-if="widget.options.useOraganization">
          <SwUserOrganization
            :widget="widget"
            :optionsList.sync="widget.options.optionsList"
            :model.sync="dataModel"
            :disabled="disabled"
            :remoteOrganization="remoteOrganization"
          ></SwUserOrganization>
        </template>
        <template v-else>
          <sw-user
            :widget="widget"
            :model.sync="dataModel"
            :disabled="disabled"
          ></sw-user>
        </template>
      </template>
      <template v-if="widget.type === 'esign'">
        <Esign
          :widget="widget"
          :nodeConfig="nodeConfig"
          v-model="dataModel"
          :disabled="disabled"
        />
      </template>

      <template v-if="widget.type === 'swtext'">
        <div
          v-if="!widget.options.isTextEditor"
          v-html="dataModel || widget.options.defaultValue"
        ></div>
        <div
          v-if="widget.options.isTextEditor"
          class="sw-edit-text ql-editor"
          v-html="dataModel || widget.options.defaultValue"
        ></div>
      </template>

      <template v-if="widget.type === 'page'">
        <generate-page
          v-if="widget.type === 'page'"
          :son-pages="sonPages"
          :widget="widget"
          :model.sync="dataModel"
          :config="config"
          :is-mobile="isMobile"
          :disabled="disabled"
          :dataType="dataType"
          :approveTip="approveTip"
          :instanceJson="instanceJson"
          :ffid="ffid"
          :yyid="yyid"
        ></generate-page>
      </template>
      <template v-if="widget.type === 'location'">
        <location
          :widget="widget"
          v-model="dataModel"
          :disabled="disabled"
        ></location>
      </template>
    </div>
  </el-form-item>
</template>

<script>
import FmUpload from './Upload'
import Esign from './Esign'
import SwFile from './advanced/file'
import Location from './advanced/location'
import SwUserOrganization from './advanced/user/userByOrganization.vue'
import SwAddress from './advanced/address'
import SwCascader from './advanced/cascader'
import SwTable from './advanced/table'
import FmEditor from './UEditor/index'
import bus from '../util/eventBus'
import globalBus from '../util/globalBus'
import countUtils from '../util/countUtils'
import generateUtils from '../util/generateUtils'
import carNumber from './advanced/carNumber'

export default {
  name: 'generate-form-item',
  props: [
    'data',
    'widget',
    'models',
    'rules',
    'remote',
    'fromSonForm',
    'fromSonPage',
    'sonFormIndex',
    'sonFormModel',
    'fromComment',
    'commentModel',
    'commentIndex',
    'lineRow',
    'lineFields',
    'isMobile',
    'scopeDisabled',
    'approveTip',
    'dataType',
    'remoteOrganization',
    'nodeConfig',
    'instanceJson',
    'ffid',
    'yyid',
  ],
  components: {
    FmUpload,
    FmEditor,
    SwFile,
    SwAddress,
    SwCascader,
    SwTable,
    Esign,
    Location,
    SwUserOrganization,
    carNumber,
  },
  data() {
    return {
      sonPages: this.data.sonPages,
      isShowLabel: true,
      ruleSetFormItem: false,
      dataModel: this.models[this.widget.model],
      pickerOptions: {}, // date 日期的配置化操作
      itemProps: '',
      showWidget: true,
      currentIndex: null, // 当前提示语的按钮索引
    }
  },
  created() {
    if (this.fromSonForm) {
      // 如果是子表单，则不显示label
      if (this.isMobile || this.config.width <= 768) {
        this.isShowLabel = true
      } else {
        this.isShowLabel = false
      }
      this.ruleSetFormItem = true
      this.itemProps =
        this.sonFormModel +
        '.' +
        this.sonFormIndex +
        '.' +
        (this.widget.type === 'address'
          ? this.widget.model + '.selectValue'
          : this.widget.model) // 设置子表单校验对象
    } else if (this.fromComment) {
      this.ruleSetFormItem = true
      this.itemProps =
        this.commentModel + '.' + this.commentIndex + '.' + this.widget.model
      // console.log(this.itemProps)
    } else {
      if (this.widget.type === 'address') {
        this.itemProps = this.widget.model + '.selectValue'
      } else if (this.widget.type === 'location') {
        this.itemProps = this.widget.model + '.formatted_address'
      } else {
        this.itemProps = this.widget.model
      }
    }
    if (this.widget.type === 'time') {
      if (this.widget.options.isRange && this.dataModel?.length === 2) {
        let startTime = this.dataModel[0]
        let endTime = this.dataModel[1]
        if (startTime.split(':').length === 2) {
          startTime += ':00'
        }
        if (endTime.split(':').length === 2) {
          endTime += ':00'
        }
        this.dataModel = [startTime, endTime]
      } else {
        if (this.dataModel?.split(':').length === 2) {
          this.dataModel += ':00'
        }
      }
    } else if (this.widget.type === 'date') {
      this.widget.options.pickerOptions = {
        disabledDate: time => {
          const startDate = +new Date(this.widget.options.startDate)
          const endDate = +new Date(this.widget.options.endDate)
          if (startDate && !endDate) {
            return time.getTime() < startDate - 24 * 60 * 60 * 1000 + 1
          }
          if (!startDate && endDate) {
            return time.getTime() > endDate
          }
          if (startDate && endDate) {
            return (
              time.getTime() < startDate - 24 * 60 * 60 * 1000 + 1 ||
              time.getTime() > endDate
            )
          }
        },
        selectableRange: '00:00:00 - 23:59:59',
      }
      this.dataModel = this.models[this.widget.model] || ''
    } else if (this.widget.type === 'file') {
      this.dataModel = this.models[this.widget.model] || []
    } else if (this.widget.type === 'switch') {
      this.dataModel = this.models[this.widget.model] || false
    } else {
      if (this.models[this.widget.model] === 0) {
        this.dataModel = 0
      } else {
        this.dataModel = this.models[this.widget.model] || ''
      }
    }

    generateUtils.initFormItem(this.widget) // 初始化  && 处理字典项、以及远程端口
    countUtils.count(this, this.widget) //  生成 字段计算监测
    this.widget.options.value = this.dataModel
  },
  mounted() {
    this.initEvent()
  },
  inject: ['validateKey'],
  methods: {
    resetDateField() {
      this.dataModel = ''
    },
    formatTimeText(t) {
      return t > 9 ? t : `0${t}`
    },
    initEvent() {
      if (this.event) {
        this.eventMethod()
      }
      globalBus.$on('setData', this.acceptSetData)
      globalBus.$on('setDefaultData', this.acceptSetDefaultData)
      globalBus.$on('showWidget', this.acceptShowWidget)
      if (this.widget.options.stress) {
        this.validateKey(this.itemProps)
      }
      globalBus.$on('widgetEvent', this.acceptWidgetEvent)
    },
    handleDateChange() {
      globalBus.$emit('dateChange', this.widget)
    },
    destroyEvent() {
      globalBus.$off('setData', this.acceptSetData)
      globalBus.$off('setDefaultData', this.acceptSetDefaultData)
      globalBus.$off('showWidget', this.acceptShowWidget)
      globalBus.$off('widgetEvent', this.acceptWidgetEvent)
    },
    // 自定义事件触发
    eventMethod() {
      const baseObjData = {
        fromSonPage: this.fromSonPage,
        widget: this.widget,
        models: {
          ...this.models,
          [this.widget.model]: this.dataModel,
        },
      }
      if (this.fromSonForm) {
        // 判断是否子表单事件
        const sonObjEvent = Object.assign(
          { lineRow: this.lineRow },
          baseObjData
        )
        bus.$emit('sonEventMethod', sonObjEvent)
      } else {
        const objEvent = Object.assign({ list: this.data.list }, baseObjData)
        bus.$emit('eventMethod', objEvent)
      }
    },
    acceptSetData(data) {
      this.$nextTick(() => {
        if (data.model !== this.widget.model) {
          return null
        }
        if (data.sonFormIndex || data.sonFormIndex === 0) {
          if (data.sonFormIndex === this.sonFormIndex) {
            this.handleSetData(data)
          }
        } else {
          this.handleSetData(data)
        }
      })
    },
    acceptSetDefaultData(data) {
      this.$nextTick(() => {
        if (data.model !== this.widget.model) {
          return null
        }
        if (data.sonFormIndex || data.sonFormIndex === 0) {
          if (data.sonFormIndex === this.sonFormIndex) {
            this.handleSetDefaultData(data)
          }
        } else {
          this.handleSetDefaultData(data)
        }
      })
    },
    handleSetData(data) {
      if (this.widget.type === 'address') {
        if (
          this.dataModel &&
          this.dataModel.selectValue &&
          this.dataModel.selectValue.length
        ) {
          this.dataModel.selectValue = data.value
        }
        if (this.dataModel && this.dataModel.inputValue) {
          this.dataModel.inputValue = data.value
        }
        return
      }

      this.dataModel = data.value
    },
    handleSetDefaultData(data) {
      if (this.widget.type === 'address') {
        if (
          this.dataModel &&
          this.dataModel.selectValue &&
          this.dataModel.selectValue.length
        ) {
          this.dataModel.selectValue = data.value
        }
        if (this.dataModel && this.dataModel.inputValue) {
          this.dataModel.inputValue = data.value
        }
        return
      }
      this.widget.options.defaultValue = data.value
    },
    acceptShowWidget(data) {
      this.$nextTick(() => {
        if (data.model !== this.widget.model) {
          return null
        }
        this.showWidget = data.isShow
      })
    },
    acceptWidgetEvent(data) {
      this.$nextTick(() => {
        if (data.model !== this.widget.model) {
          return null
        }
        this.eventMethod()
      })
    },
    // 写入审批语
    writeIn(index) {
      this.dataModel = this.widget.options.ApprovalLanguage[index]
      this.currentIndex = index
    },
    handleMaxlength(num, length, type) {
      if (type === 'number' || type === 'integer' || type === 'float') {
        let data = String(num) //将输入的数值转换成字符串
        if (data.length > length) {
          // 限制的长度
          // $nextTick 将数据渲染到页面，不加这一步，赋值无效
          this.$nextTick(() => {
            this.dataModel = Number(data.slice(0, length))
          })
        }
      }
    },
  },
  watch: {
    dataModel: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.widget.options.value = newVal
        if (this.widget.type !== 'swtext') {
          this.widget.options.defaultValue = newVal
        }
        // 将model加入models中
        const newModels = {
          ...this.models,
          [this.widget.model]: newVal,
        }
        if (this.showItemFlag) {
          // 修复地址组件和评阅组件第一次校验失败问题（暂未找出原因，可能是先校验了才把值传过去导致的问题）

          this.validateKey(this.itemProps)
        }
        if (this.widget.type === 'radio') {
          this.eventMethod()
        }

        // 比较this.models中的此控件的值（传入的models）与当前改变的值，如果有不同即当前控件值发生了改变
        // if (
        //   JSON.stringify(this.models[this.widget.model]) ===
        //   JSON.stringify(newVal)
        // ) {
        //   return
        // }
        this.$emit('update:models', newModels)
        if (this.widget.type === 'input' && this.event === 'input') {
          this.eventMethod()
        }
        if (this.fromSonForm) {
          this.widget.sonFormIndex = this.sonFormIndex
          this.widget.sonFormModel = this.sonFormModel
        }
        if (this.widget.type === 'date') {
          const h1 = new Date(this.widget.options.startDate)?.getHours()
          const m1 = new Date(this.widget.options.startDate)?.getMinutes()
          const s1 = new Date(this.widget.options.startDate)?.getSeconds()
          const h2 = new Date(this.widget.options.endDate)?.getHours()
          const m2 = new Date(this.widget.options.endDate)?.getMinutes()
          const s2 = new Date(this.widget.options.endDate)?.getSeconds()
          console.log(newVal, 'newVal')
          if (
            this.widget.options.type === 'date' ||
            this.widget.options.type === 'datetime' ||
            this.widget.options.type === 'month'
          ) {
            if (
              this.widget.options.startDate &&
              newVal.split(' ')[0] ===
                this.widget.options.startDate.split(' ')[0]
            ) {
              this.widget.options.pickerOptions.selectableRange = `${this.formatTimeText(
                h1
              )}:${this.formatTimeText(m1)}:${this.formatTimeText(
                s1
              )} - 23:59:59`
            } else if (
              this.widget.options.endDate &&
              newVal.split(' ')[0] === this.widget.options.endDate.split(' ')[0]
            ) {
              this.widget.options.pickerOptions.selectableRange = `00:00:00 - ${this.formatTimeText(
                h2
              )}:${this.formatTimeText(m2)}:${this.formatTimeText(s2)}`
            } else {
              this.widget.options.pickerOptions.selectableRange =
                '00:00:00 - 23:59:59'
            }
            if (+new Date(newVal) <= +new Date(this.widget.options.startDate)) {
              this.dataModel = this.widget.options.startDate
            }
            if (+new Date(newVal) >= +new Date(this.widget.options.endDate)) {
              this.dataModel = this.widget.options.endDate
            }
          } else if (
            this.widget.options.type === 'daterange' ||
            this.widget.options.type === 'datetimerange'
          ) {
            // datetimerange无法限制两个time时间选择
            if (
              newVal &&
              newVal.length > 0 &&
              newVal[0].split(' ')[0] ===
                this.widget.options.startDate.split(' ')[0]
            ) {
              this.widget.options.pickerOptions.selectableRange = `${this.formatTimeText(
                h1
              )}:${this.formatTimeText(m1)}:${this.formatTimeText(
                s1
              )} - 23:59:59`
            } else if (
              newVal &&
              newVal.length > 0 &&
              newVal[0].split(' ')[0] ===
                this.widget.options.endDate.split(' ')[0]
            ) {
              this.widget.options.pickerOptions.selectableRange = `00:00:00 - ${this.formatTimeText(
                h2
              )}:${this.formatTimeText(m2)}:${this.formatTimeText(s2)}`
            } else {
              this.widget.options.pickerOptions.selectableRange =
                '00:00:00 - 23:59:59'
            }
            if (
              newVal &&
              newVal.length > 0 &&
              +new Date(newVal[0]) < +new Date(this.widget.options.startDate)
            ) {
              newVal[0] = this.widget.options.startDate
            }
            if (
              newVal &&
              newVal.length > 0 &&
              +new Date(newVal[1]) > +new Date(this.widget.options.endDate)
            ) {
              newVal[1] = this.widget.options.endDate
            }
          }
        }
        globalBus.$emit('dataChange', this.widget)
      },
    },
    models: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.dataModel === val[this.widget.model]) {
          return
        }
        // if (this.fromSonPage) {
        //   return
        // }
        this.dataModel = val[this.widget.model]
      },
    },
    widget: {
      deep: true,
      immediate: true,
      handler(val) {
        if (
          this.fromSonPage &&
          typeof val.options.defaultValue === 'string' &&
          val.options.defaultValue
        ) {
          console.log('---------widget----------', val)
          console.log('---------this.models----------', this.models)
          this.dataModel = val.options.defaultValue
          this.models[val.model] = val.options.defaultValue
        }
      },
    },
  },
  computed: {
    event() {
      return Object.prototype.hasOwnProperty.call(this.widget, 'eventOptions')
        ? this.widget.eventOptions.eventType
        : ''
    },
    config() {
      return this.data.config
    },
    disabled() {
      return (
        (this.fromSonForm &&
          (this.lineRow.disabled ||
            (!this.widget.options.disabled && this.lineFields.disabled))) ||
        this.widget.options.disabled ||
        this.scopeDisabled ||
        this.config.disabled
      )
    },
    showItemFlag() {
      return this.fromSonForm
        ? this.lineFields && !this.lineFields.hidden
        : this.widget.options && !this.widget.options.hidden
    },
    itemRules() {
      if (this.fromComment) {
        return this.widget.rules
      }
      return this.rules
    },
  },
  destroyed() {
    this.destroyEvent()
  },
}
</script>
<style scoped lang="scss">
.sw-file-show a {
  padding-right: 14px;
  text-decoration: none;
}
.textareaTip {
  width: 100%;
  content: '';
  clear: both;
  display: flex;
  .tipPart {
    font-size: 12px;
    .tipTitle {
      margin-right: 6px;
      color: #606266;
    }
  }
  .languageList {
    flex: 1;
    font-size: 12px;
  }
  .languageList .el-button--small {
    height: 22px;
    line-height: 20px;
    padding: 0 8px;
    border: 1px solid #d3d3d3;
    background: #ffffff;
    border-radius: 2px;
    float: left;
    margin-top: 6px;
    font-size: 12px;
    color: #606266;
  }
  .languageList .el-button--small.actived {
    background: #f5f5f5;
    border: 1px solid #e6e6e6;
    color: #cccccc;
  }
}
.textareaTip.hideBtn {
  display: none;
}

.sw-edit-text {
  min-height: auto;
  margin: 0;
  padding: 0;
  line-height: 32px;
}
</style>
<style>
.el-textarea__inner {
  font-family: Arial;
  height: 100%;
}
</style>
